import CryptoJS from 'crypto-js'

const KEY = CryptoJS.enc.Utf8.parse('X7k9Pz2Mw4L5R8tQ')

/**
 * AES 加密
 */
export function encryptAES(data) {
  const jsonStr = JSON.stringify(data)

  const encrypted = CryptoJS.AES.encrypt(jsonStr, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  return encrypted.toString() // Base64
}

/**
 * AES 解密
 */
/**
 * AES 解密（只在确定是 JSON 时才 JSON.parse）
 */
export function decryptAES(cipherText) {
  if (typeof cipherText !== 'string') return cipherText

  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText, KEY, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    const result = decrypted.toString(CryptoJS.enc.Utf8)
    if (!result) return cipherText
    if (isJsonString(result)) {
      return JSON.parse(result)
    }
    return result
  } catch (e) {
    return cipherText
  }
}
function isJsonString(str) {
  if (typeof str !== 'string') return false

  const s = str.trim()

  // JSON 必须以 { 或 [ 开头
  if (!(s.startsWith('{') || s.startsWith('['))) return false

  try {
    const parsed = JSON.parse(s)
    return typeof parsed === 'object' && parsed !== null
  } catch {
    return false
  }
}
export function isBase64String(data) {
  // 1. 必须是字符串
  if (typeof data !== 'string') return false

  // 2. 长度必须是 4 的倍数（Base64 硬规则）
  if (data.length % 4 !== 0) return false

  // 3. 不能包含非法字符
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/

  return base64Regex.test(data)
}
